import { render, staticRenderFns } from "./postage.vue?vue&type=template&id=ce915dc6&scoped=true&"
import script from "./postage.vue?vue&type=script&lang=js&"
export * from "./postage.vue?vue&type=script&lang=js&"
import style0 from "./postage.vue?vue&type=style&index=0&id=ce915dc6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce915dc6",
  null
  
)

export default component.exports